var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{class:_vm.block.class ? _vm.block.class : 'primary--text text-h4',attrs:{"cols":_vm.block.cols,"xs":_vm.block.colsxs,"sm":_vm.block.colssm,"md":_vm.block.colsmd,"lg":_vm.block.colslg,"xl":_vm.block.colsxl,"offset":_vm.block.offset},domProps:{"innerHTML":_vm._s(_vm.block.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }